import i18n, { t } from 'i18next';

import { Card, CardDivider, CardHeader, CardText } from '@/components/atoms/Card';
import type { DailyWelfareData, WelfareMetrics } from '@/domain/welfare/types';
import { localizedDateFormat } from '@/utils/date';
import { formatFractionAsPercentageByLocale, formatNumberByLocale } from '@/utils/localeFormatters';

import ViewButton from './ViewButton';

import styles from '../CageWelfareDashboard.module.scss';

interface WoundInsightCardProps {
    lastFishHealthDay: DailyWelfareData | null;
    lastEstimate: WelfareMetrics | null;
    onView: () => void;
}

/** The latest day's measurement count and the share of fish without wounds. */
export default function WoundInsightCard(props: WoundInsightCardProps) {
    const { lastFishHealthDay, lastEstimate, onView } = props;

    return (
        <Card
            padding="lg"
            header={
                <CardHeader
                    title={t('cageWelfare.common.woundInsight')}
                    level="h2"
                    size="card"
                    actions={
                        <ViewButton trackingId="welfare_dashboard_view_wounds" onClick={onView} />
                    }
                />
            }>
            <div>
                <div className={styles.umerboxContentContainer}>
                    {lastFishHealthDay && (
                        <div className={styles.spaceBetweenFlex}>
                            <CardText>{`${t('cageWelfare.dashboard.numberOfMeasurements')} ${localizedDateFormat(
                                {
                                    dateString: lastFishHealthDay.day,
                                    onlydate: true,
                                    locale: i18n.language,
                                }
                            )}`}</CardText>
                            <div className={styles.flowRight}>
                                <CardText>
                                    {formatNumberByLocale(
                                        lastFishHealthDay.count,
                                        i18n.language,
                                        0
                                    )}
                                </CardText>
                            </div>
                        </div>
                    )}

                    {lastEstimate && (
                        <div className={styles.smallInfoTable}>
                            <div className={styles.spaceBetweenFlex}>
                                <CardText variant="footnote">
                                    {t('common.labels.noWounds')}
                                </CardText>
                            </div>
                            <CardDivider />
                            <div className={styles.spaceBetweenFlex}>
                                <CardText>
                                    {!lastEstimate.noWound
                                        ? '-'
                                        : formatFractionAsPercentageByLocale(
                                              lastEstimate.noWound,
                                              i18n.language
                                          )}
                                </CardText>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
}
